import Pattern from '../ASSETS/SymbolicaPattern.png';

export const Background = `radial-gradient(transparent, black 100%), url(${Pattern})`;
